// src/components/auth/AdminProfil/AdminDash.js
import React, { useEffect, useState, useRef } from "react";
import { useAuth } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { getDashboardStats } from "../../../services/api";
import Chart from "chart.js/auto";
import UserProfile from "../userProfile/UserProfile";
import "../../../styles/AdminDash.css";

export default function AdminDash() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // États pour stats
  const [stats, setStats] = useState(null);

  // Refs pour les canvas Chart.js
  const activityRef = useRef(null);
  const evolutionRef = useRef(null);
  const monthlyRef = useRef(null);
  const pieRef = useRef(null);

  // Récupère les stats du backend
  useEffect(() => {
    getDashboardStats().then(setStats);
  }, []);

  // Initialise les graphiques quand stats changent
  useEffect(() => {
    if (!stats) return;
    // Nettoyage des anciens graphiques si besoin
    let charts = [];

    if (activityRef.current) {
      charts.push(
        new Chart(activityRef.current, {
          type: "line",
          data: {
            labels: stats.activity.labels,
            datasets: [
              {
                label: "Activité Générale",
                data: stats.activity.data,
                borderColor: "#2b458f",
                backgroundColor: "rgba(43,69,143,0.08)",
                fill: true,
                tension: 0.3,
              },
            ],
          },
          options: { plugins: { legend: { display: false } } },
        })
      );
    }
    if (evolutionRef.current) {
      charts.push(
        new Chart(evolutionRef.current, {
          type: "bar",
          data: {
            labels: stats.evolution.labels,
            datasets: [
              {
                label: "Évolution",
                data: stats.evolution.data,
                backgroundColor: "#d93a3a",
              },
            ],
          },
          options: { plugins: { legend: { display: false } } },
        })
      );
    }
    if (monthlyRef.current) {
      charts.push(
        new Chart(monthlyRef.current, {
          type: "line",
          data: {
            labels: stats.monthly.labels,
            datasets: [
              {
                label: "Enrichissement Mensuel",
                data: stats.monthly.data,
                borderColor: "#1e336c",
                backgroundColor: "rgba(30,51,108,0.08)",
                fill: true,
                tension: 0.3,
              },
            ],
          },
          options: { plugins: { legend: { display: false } } },
        })
      );
    }
    if (pieRef.current) {
      charts.push(
        new Chart(pieRef.current, {
          type: "pie",
          data: {
            labels: stats.pie.labels,
            datasets: [
              {
                data: stats.pie.data,
                backgroundColor: [
                  "#2b458f",
                  "#d93a3a",
                  "#f9d923",
                  "#4ea699",
                  "#e5ecf7",
                ],
              },
            ],
          },
        })
      );
    }
    // Nettoyage à chaque update
    return () => charts.forEach((chart) => chart.destroy());
  }, [stats]);

  return (
    <div className="admin-dash-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img src="/logo.png" alt="Logo" />
        </div>
        <nav>
          <ul>
            <li>
              <button onClick={() => navigate("/admin")}>Admin</button>
            </li>
            <li>
              <button className="active" onClick={() => navigate("/admin/dashboard")}>
                Tab de Bord
              </button>
            </li>
            <li>
              <button onClick={() => navigate("/admin/messages")}>Messages</button>
            </li>
            <li>
              <button onClick={() => navigate("/admin/validation")}>Validation</button>
            </li>
            <li>
              <button onClick={() => navigate("/")}>Accueil</button>
            </li>
          </ul>
        </nav>
        <div className="sidebar-logout">
          <button onClick={() => {
            // Ajoute ta logique de logout ici
            navigate("/login");
          }}>LOGOUT</button>
        </div>
      </aside>

      {/* Main dashboard */}
      <main className="dashboard-main">
        <div className="dashboard-charts">
          <div className="chart-card">
            <canvas ref={activityRef}></canvas>
          </div>
          <div className="chart-card">
            <canvas ref={evolutionRef}></canvas>
          </div>
          <div className="chart-card">
            <canvas ref={monthlyRef}></canvas>
          </div>
          <div className="chart-card">
            <canvas ref={pieRef}></canvas>
          </div>
        </div>
        <div className="dashboard-buttons">
          <button onClick={() => navigate("/dictionary")}>Dictionnaire Total</button>
          <button onClick={() => navigate("/admin/dictionary")}>Nouveaux Termes</button>
          <button onClick={() => navigate("/admin/projects")}>Nouveaux Projets</button>
          <button onClick={() => navigate("/admin/comments")}>Nouveaux Commentaire</button>
          <button onClick={() => navigate("/admin/users")}>Table Des Utilisateurs</button>
          <button onClick={() => navigate("/projects")}>Table Des Projets</button>
        </div>
      </main>
    </div>
  );
}
